import React from 'react'
import SendbirdApp from "@sendbird/uikit-react/App";
import "@sendbird/uikit-react/dist/index.css";
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import './ChatPage.css'

const ChatPageUI = ({context, chatUser, errorList, onRefreshClick}) =>
  <PrivatePageSF context={context} className='pg_chat' topnav='chat' headerText='Chat'
     centered={!chatUser && !errorList}
  >
    {
      !chatUser && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {/* https://sendbird.com/docs/uikit/v3/react/overview */}
    {
      chatUser &&
      <>
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
        </div>
        appId={chatUser.appId}<br/>userId={chatUser.userId}<br/>nickname={chatUser.userName}<br/>accessToken={chatUser.accessToken}
        <div className="App">
          <SendbirdApp
            appId={chatUser.appId}
            userId={chatUser.userId}
            nickname={chatUser.userName}
            accessToken={chatUser.accessToken}
            profileUrl='https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50'
          />
        </div>
      </>
    }
  </PrivatePageSF>

export default ChatPageUI
